<div>
    <app-nav></app-nav>
    <div class="hero is-fullheight">
        <section class="my-5">
            <router-outlet></router-outlet>
        </section>
        <app-footer></app-footer>
    </div>
</div>